// eBay Browse API — coverage. Grounded in server/src/channels/ebay/client.js
// (getItemByLegacyId). Public listing lookup for product-question grounding.
export default {
  api: 'eBay Browse API',
  blurb:
    "Looks up a public listing's details by legacy item id (the conversation's referenceId) to ground product questions. Auth: an APPLICATION (client-credentials) token (getAppAccessToken()) as Bearer — no user/consent needed. Read-only, gated by EBAY_READ_ENABLED; best-effort (callers tolerate null). Nothing persisted.",
  endpoints: [
    {
      verb: 'GET', path: '/item/get_item_by_legacy_id?legacy_item_id={id}', fn: 'getItemByLegacyId()', rw: 'read',
      params: [
        { p: 'legacy_item_id', req: 'required', send: 'y', val: "The listing's legacy item id (conversation referenceId)" },
      ],
      fields: [
        { f: 'title', pull: true, db: null, note: 'Listing title — product-question grounding + CSR context', badge: 'pull' },
        { f: 'price.{value,currency}', pull: true, db: null, note: 'Formatted as "<value> <currency>"', badge: 'pull' },
        { f: 'image.imageUrl', pull: true, db: null, note: 'Primary listing image', badge: 'pull' },
        { f: 'itemWebUrl', pull: true, db: null, note: 'Public listing URL', badge: 'pull' },
        { f: 'condition / seller / itemSpecifics / shippingOptions / …', pull: false, db: null, note: 'Browse returns a large item object; only the four fields above are projected', badge: 'avail' },
      ],
    },
  ],
}
